import _ from "lodash";
import { createSelector } from "reselect";

const usersKey = "profileState";

export const getProfileState = (state) => _.get(state, usersKey);

export const getProfileData = createSelector(getProfileState, (state) =>
  _.get(state, "profileStateList")
);

export const getDriverBirthdayModal = createSelector(getProfileState, (state) =>
  _.get(state, "profileDriverBirthdayModalState")
);

export const getDriverLicenseModal = createSelector(getProfileState, (state) =>
  _.get(state, "profileDriverLicenseModalState")
);

export const getDriverEmailModal = createSelector(getProfileState, (state) =>
  _.get(state, "profileDriverEmailModalState")
);

export const getDriverAddressModal = createSelector(getProfileState, (state) =>
  _.get(state, "profileDriverAddressModalState")
);

export const getDriverPhoneModal = createSelector(getProfileState, (state) =>
  _.get(state, "profileDriverPhoneModalState")
);

export const getDriverVehicleOptionsModal = createSelector(
  getProfileState,
  (state) => _.get(state, "profileDriverVehicleOptionsModalState")
);

export const getDriverEmailOptionsModal = createSelector(
  getProfileState,
  (state) => _.get(state, "profileDriverEmailOptionsModalState")
);

export const getDriverAddressOptionsModal = createSelector(
  getProfileState,
  (state) => _.get(state, "profileDriverAddressOptionsModalState")
);

export const getDriverPhoneOptionsModal = createSelector(
  getProfileState,
  (state) => _.get(state, "profileDriverPhoneOptionsModalState")
);

export const getDriverEditVehicleModal = createSelector(
  getProfileState,
  (state) => _.get(state, "profileDriverEditVehicleState")
);

export const getDriverEditEmailModal = createSelector(
  getProfileState,
  (state) => _.get(state, "profileDriverEditEmailState")
);

export const getDriverEditAddressModal = createSelector(
  getProfileState,
  (state) => _.get(state, "profileDriverEditAddressState")
);

export const getDriverEditPhoneModal = createSelector(
  getProfileState,
  (state) => _.get(state, "profileDriverEditPhoneState")
);

export const SelectedEmail = createSelector(getProfileState, (state) =>
  _.get(state, "SelectedEmail")
);

export const SelectedVehicle = createSelector(getProfileState, (state) =>
  _.get(state, "SelectedVehicle")
);

export const SelectedAddress = createSelector(getProfileState, (state) =>
  _.get(state, "SelectedAddress")
);

export const SelectedPhone = createSelector(getProfileState, (state) =>
  _.get(state, "SelectedPhone")
);

export const profileDriverEditEmailApiState = createSelector(
  getProfileState,
  (state) => _.get(state, "profileDriverEditEmailApiState")
);

export const profileDriverEditVehicleApiState = createSelector(
  getProfileState,
  (state) => _.get(state, "profileDriverEditVehicleApiState")
);

export const profileDriverEditAddressApiState = createSelector(
  getProfileState,
  (state) => _.get(state, "profileDriverEditAddressApiState")
);

export const profileDriverEditPhoneApiState = createSelector(
  getProfileState,
  (state) => _.get(state, "profileDriverEditPhoneApiState")
);

export const getProfileVehicleMakeStates = createSelector(
  getProfileState,
  (state) => _.get(state, "profileVehicleMakeList")
);

export const getProfileVehicleDetails = createSelector(
  getProfileState,
  (state) => _.get(state, "getProfileVehicleDetails")
);

export const getProfileEmailDetails = createSelector(getProfileState, (state) =>
  _.get(state, "getProfileEmailDetails")
);

export const getProfileAddressDetails = createSelector(
  getProfileState,
  (state) => _.get(state, "getProfileAddressDetails")
);

export const getProfilePhoneDetails = createSelector(getProfileState, (state) =>
  _.get(state, "getProfilePhoneDetails")
);

export const getStatesSelector = createSelector(getProfileState, (state) =>
  _.get(state, "states")
);

export const getMyAccountEditorSelector = createSelector(
  getProfileState,
  (state) => _.get(state, "MyAccountEditorData")
);

export const getReviewAndOrderEditorSelector = createSelector(
  getProfileState,
  (state) => _.get(state, "reviewAndOrderEditorData")
);

export const getPaymentPageEditorSelector = createSelector(
  getProfileState,
  (state) => _.get(state, "paymentPageEditorData")
);

export const getCheckboxAgreementTextEditorSelector = createSelector(
  getProfileState,
  (state) => _.get(state, "checkboxAgreementTextEditorData")
);

export const getOrderCompletePageEditorSelector = createSelector(
  getProfileState,
  (state) => _.get(state, "orderCompletePageEditorData")
);

export const getCitationInformationEditorSelector = createSelector(
  getProfileState,
  (state) => _.get(state, "citationInformationPageEditorData")
);

export const getTermsOfUsesEditorSelector = createSelector(
  getProfileState,
  (state) => _.get(state, "termsOfUsesEditorData")
);

export const getCitationDetailsPageEditorSelector = createSelector(
  getProfileState,
  (state) => _.get(state, "citationDetailsPageEditorData")
);

export const getPaymentTextCitationEditorSelector = createSelector(
  getProfileState,
  (state) => _.get(state, "paymentTextCitationEditorData")
);

export const getPaymentAcceptedTextCitationEditorSelector = createSelector(
  getProfileState,
  (state) => _.get(state, "paymentAcceptedTextCitationEditorData")
);

export const getAppealFineHeaderEditorSelector = createSelector(
  getProfileState,
  (state) => _.get(state, "appealFineHeaderEditorData")
);

export const getvehicleDetailsdata = createSelector(
  getProfileState,
   (state) => _.get(state, "profileDriverGetVehicleDetails")
);

export const getAccountDriverInformationdata = createSelector(
  getProfileState, 
  (state) => _.get(state, "accountDriverVehicleDetails")
)
export const getAccountDriverBillingAddress = createSelector(
  getProfileState, 
  (state) => _.get(state, "profileDriverAddNewBillingAddressState")
)